<template>
  <div class="card-container">
    <div class="card-container__inner">
      <div class="card-container__header">
        <h3 class="card-container__title title title--tertiary"> 
          {{t('popular_services')}}
        </h3>
      </div>
      <div class="card-container__body">
        <swiper
          :slides-per-view="6"
          :space-between="10"
          :breakpoints="breakpoints"
          :pagination="pagination"
          :modules="modules"
          :navigation="false" 
          class="mySwiper"
        >
          <swiper-slide
            v-for="service in serviceList"
            :key="service.id"
          >
            <div class="carousel__item card-container__item">
              <div :class="['service-card-primary', {'service-card-primary--all': (service.id === 9999)}]">
                <router-link
                  class="service-card-primary__link"
                  :to="service.id === 9999 ? {name: 'service-category'} : { name: 'service', params: { id: service.id, name: service.name, fromMain: true }}"
                >
                  <div class="service-card-primary__inner">
                    <div class="service-card-primary__header">
                      <div
                        class="service-card-primary__title"
                        :title="service.name"
                      >
                        {{ service.name }}
                      </div> 
                      <div class="service-card-primary__subtitle">{{ service.catalog_name }}</div> 
                    </div>
                    <div class="service-card-primary__body">
                      <img
                        v-if="service.icon"
                        :src="service.icon"
                        alt="icon"
                        class="service-card-primary__img"
                      >
                      <div
                        v-else
                        class="service-card-primary__text"
                      >
                        {{service.description}}
                      </div>
                    </div>
                    <div class="service-card-primary__footer">
                      <div class="service-card-primary__arrow">
                        <svg
                          id="arrow"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.5 13L14 8M14 8L9.5 3M14 8L2 8"
                            stroke="#6059F4"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div> 
          </swiper-slide>
        </swiper>
        <div class="swp-pagination" />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { Navigation as Nv, Pagination as Pg } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';

import { DEFAULT } from '@/constant';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export default defineComponent({
  components: {
    SwiperSlide,
    Swiper,
    Pg
  },  

  setup() {

    const store = useStore();
    const { t } = useI18n();
    
    const breakpoints = ref({
      320: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
      375: {
        slidesPerView: 1.7,
        spaceBetween: 5,
      },
      480: {
        slidesPerView: 3,
        spaceBetween: 5,
        pagination: {
          clickable: false,
        }
      },
      768:{
        slidesPerView: 4,
        spaceBetween: 5,

      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 10,
      },
      1280: {
        slidesPerView: 6,
        spaceBetween: 20, 
      }
    });
    const pagination =ref({
      clickable: true,
      el: '.swp-pagination',
      renderBullet: function (index, className) {
        return '<span class="' + className + '"><span class="swp-pagination__item"><div class="pagination-item"></div></span></span>';
      },
    });

    const serviceList = computed(() =>  {
      const { favorites, catalogs } = store.getters['services/services'];
      const merchantName = store.getters['merchant'];
            
      if (favorites) {
        let favoritesValues = Object.values(favorites).map(item => JSON.parse(JSON.stringify(item)));
        let catalogsValues = Object.values(catalogs).map(item => JSON.parse(JSON.stringify(item)));

        const temp = favoritesValues.map((i) => {
          let b = {};
          catalogsValues.forEach((j) => {
            if (j.id === i.catalogs[0]) {
              b = { 
                catalog_name: j.name,
                ...i
              };
            }
          });
          return b;
        });
        
        merchantName === DEFAULT 
          ? temp.push({
            name: t('all_services'),
            icon: require('@/assets/img/category.png'),
            id: 9999,
            url: '/service-category' 
          })
          : temp.push({
            name: t('all_services'),
            id: 9999,
            url: '/service-category',
            description: '50+'
          });
        return temp;
      }
      
      return [];
    });

    return {
      breakpoints,
      modules: [Pg, Nv],
      pagination,
      serviceList,
      t
    };
  },
});
</script>
<style lang="scss" scoped>
.card-container{
    &__header{
      margin-bottom: 24px;
    }
    &__item{
      max-width: 185px;
      width: 100%;
      
    }
}

.service-card-primary{
  background: $primary-white;
    border-radius: 8px;
    width: 100%;
    cursor: pointer;
    &__inner{
      padding: 16px;
      height: 264px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    &__body{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 14px;
    }
    &__title{
      margin-bottom: 2px;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &__subtitle{
      font-size: 14px;
    }
    &__img{
        display: block;
        margin: auto;
        max-height: 137px;
        max-width: 137px;
        height: 100%;
        width: 100%;
    }
    &__arrow{
      width: max-content;
      margin-left: auto;
    }
    &__link{
      display: block;
      height: 100%;
    }
    &__text{
      width: 120px;
      height: 120px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid;
      border-radius: 60%;
      font-weight: 600;
      font-size: 28px;
      line-height: 34px;
    }
    &--all{
      background-color: $primary-purple;
      .service-card-primary{
        &__title{
          color: $primary-white;
        }
      }
    }
}
.altel, .tele2{
  .service-card-primary{
    &__subtitle{
      color: $primary-gray;
    }
    &__title{
      white-space: normal;
      overflow: hidden;
      text-overflow:unset;

    }
  }
  .service-card-primary--all{
    .service-card-primary{
      &__title{
        color: $primary-white;
      }
    }
  }
}
.tele2{
  .card-container{
    &__title{
      font-weight: 600;
      color: $tele2-primary-black;
    }
  }
  .service-card-primary{
    &--all{
      background-color: $primary-black;
    }
    &__text{
      color: $primary-white;
      border-color: $primary-white;
    }
    &__title{
      font-weight: 600;
      font-size: 18px;
      line-height: 22px;
      color: $tele2-primary-black;
    }
    &__subtitle{
      font-weight: 400;
      font-size: 14px;
      line-height: 130%;
      color: $tele2-secondary-gray;
    }
    &__title, &__subtitle{
      font-family: 'Open Sans';
    }
  }
  .service-card-primary:hover{
    svg#arrow path{
      fill: $secondary-blue;
      stroke: $secondary-blue;
    }
  }
  
  .service-card-primary--all{
    svg#arrow path{
      fill: $primary-white;
      stroke: $primary-white;
    }
  }

  svg#arrow path{
    fill: $tele2-primary-gray;
    stroke: $tele2-primary-gray;
  }
}
.altel{
  .card-container{
    &__title{
      color: $altel-primary-black;
      font-weight: 600;
    }
  }
  .service-card-primary{
    &--all{
      background-color: $primary-pink;
    }
    &__text{
      color: $primary-white;
      border-color: $primary-white;
    }
    &__header{
      font-weight: 600;
      font-size: 18px;
    }
    &__subtitle{
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: $altel-secondary-gray;

    }
    &__title{
      font-weight: 500;
      font-size: 18px;
      line-height: 23px;
      color: $altel-primary-black;
    }
    &__title, &__subtitle{
      font-weight: normal;
    }
  }
  .service-card-primary:hover{
     svg#arrow{
      border: 1px solid $primary-pink;
      background: $primary-pink;
      border-radius: 50%;
     }
    svg#arrow path{
      fill: $primary-white;
      stroke: $primary-white;
    }
  }
  .service-card-primary--all{
    .service-card-primary{
      &__title{
        color: $primary-white;
      }
    }
    svg#arrow path{
      fill: $primary-white;
      stroke: $primary-white;
    }
  }

  svg#arrow path{
    fill: $primary-gray;
    stroke: $primary-gray;
  }
}
@media (min-width: 320px) and (max-width: 374px) {
.card-container{
  &__header{
    margin-bottom: 24px;
  }
  &__title{
    font-size: 28px;
  }
}
}
@media (min-width: 375px) and (max-width: 480px) {
  .card-container{
    &__item{
      // max-width: 250px;
      width: 100%;
      margin: 0 10px;
    }
    &__header{
      margin-bottom: 24px;
    }
    &__title{
      font-size: 28px;
    }
  }
}
@media (min-width: 481px) and (max-width: 640px) {
  .card-container{
    &__item{
      // max-width: 350px;
      width: 100%;
      margin: 0 10px;
    }
    &__header{
      margin-bottom: 24px;
    }
    &__title{
      font-size: 32px;
    }
  }
}
</style>